import { Box, CircularProgress, LinearProgress, ThemeProvider } from "@mui/material";
import theme from "../style/theme";

export default function LoadingBarApp() {
    return <Box sx={{ width: '100%' }}>
      <ThemeProvider theme={theme}>
        <LinearProgress/>
      </ThemeProvider>
    </Box>;
}

export function CircularLoaing() {
  return <ThemeProvider theme={theme}>
    <CircularProgress size={50}/>
  </ThemeProvider>
}